import React from 'react';

import AuthActions from 'auth/AuthActions';
import BoxBody from 'components/BoxBody.jsx';
import BoxFooter from 'components/BoxFooter.jsx';
import Button from 'components/Button.jsx';
import CenteredLoadingIndicator from 'components/CenteredLoadingIndicator.jsx';
import CurrentUser from 'auth/CurrentUser';
import Dialog from 'components/Dialog.jsx';
import GroupActions from 'groups/actions/GroupActions';
import GroupStore from 'groups/stores/GroupStore';
import JoinGroupAvatarPanel from 'join/components/JoinGroupAvatarPanel.jsx';
import Link from 'components/Link.jsx';
import ToastActions from 'actions/ToastActions';
import Modal from 'components/Modal.jsx';

import './styles/JoinConfirmSubscriptionModal.scss';

const JoinConfirmSubscriptionModal = React.createClass({

  propTypes: {
    code: React.PropTypes.string.isRequired,
  },

  contextTypes: {
    router: React.PropTypes.object.isRequired,
  },

  getInitialState() {
    return {
      group: null,
    };
  },

  componentDidMount() {
    this.loadGroup(this.props.code);
  },

  bypass() {
    this.context.router.push('/classes');
  },

  loadGroup(code) {
    const onNotFound = () => {
      ToastActions.showErrorToast('Group not found.');
      this.props.onRequestHide();
    };

    const onSuccess = (group) => {
      if (GroupStore.isConnectedToGroup(group)) {
        ToastActions.showErrorToast('You have already joined this class.');
        this.props.onRequestHide();
      } else if (!group.canJoin()) {
        ToastActions.showErrorToast('Can’t join this class');
        this.props.onRequestHide();
      } else {
        this.setState({ group });
      }
    };

    GroupActions
      .searchGroupByCode(code)
      .then(onSuccess, onNotFound);
  },

  signOutRequest() {
    AuthActions.signOut(`/join/${this.props.code}`);
  },

  subscribe() {
    const onSuccess = (group) => {
      ToastActions.showSuccessToast(
        `You’ve joined ${group.getName()}`
      );
      this.props.onRequestHide();
      this.context.router.push(`/classes/${group.getCode()}`);
    };

    const onError = (error) => {
      ToastActions.showErrorToast(error.message);
      this.props.onRequestHide();
    };

    GroupActions.subscribeToGroupWithCode(this.props.code).then(onSuccess, onError);
  },

  render() {
    if (!this.state.group) {
      return (
        <Modal>
          <CenteredLoadingIndicator />
        </Modal>
      );
    }
    return (
      <Dialog {...this.props} eventScreenName="JoinConfirmSubscriptionModal" size="xsmall">
        <BoxBody className="JoinConfirmSubscriptionModal">
          <JoinGroupAvatarPanel group={this.state.group} />
          <Button
            full
            onClick={this.subscribe}
            className="JoinConfirmSubscriptionModal-Button">
            Join class
          </Button>
        </BoxBody>
        <BoxFooter>
          {`Logged in as ${CurrentUser.getUser().getSignature()}`}<br />
          Not you? <Link onClick={this.signOutRequest}>Log out</Link>
        </BoxFooter>
      </Dialog>
    );
  },
});

export default JoinConfirmSubscriptionModal;



// WEBPACK FOOTER //
// ./src/join/components/JoinConfirmSubscriptionModal.jsx